import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31084650"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab px-2" }
const _hoisted_2 = { class: "flex flex-col mx-6 my-4 gap-5 h-[232px] text-Text/text_medium gordita-400-13 leading-[150%]" }
const _hoisted_3 = {
  key: 0,
  class: "ide flex flex-col gap-5"
}
const _hoisted_4 = { class: "line1" }
const _hoisted_5 = { class: "gordita-500-13-m text-Text/text_high" }
const _hoisted_6 = {
  key: 0,
  class: "line2"
}
const _hoisted_7 = {
  key: 1,
  class: "cmd flex flex-col gap-5"
}
const _hoisted_8 = { class: "line1" }
const _hoisted_9 = { class: "ibm-mono-400-12 bg-Hovers/hover_grey border-[2px] px-1" }
const _hoisted_10 = { class: "line2" }
const _hoisted_11 = { class: "ibm-mono-400-12 bg-Hovers/hover_grey border-[2px] px-1" }
const _hoisted_12 = { class: "line3" }
const _hoisted_13 = { class: "ibm-mono-400-12 bg-Hovers/hover_grey border-[2px] px-1" }
const _hoisted_14 = {
  key: 0,
  class: "line4"
}
const _hoisted_15 = {
  key: 2,
  class: "ninja flex flex-col gap-5"
}
const _hoisted_16 = { class: "line1" }
const _hoisted_17 = { class: "ibm-mono-400-12 bg-Hovers/hover_grey border-[2px] px-1" }
const _hoisted_18 = { class: "line2" }
const _hoisted_19 = { class: "ibm-mono-400-12 bg-Hovers/hover_grey border-[2px] px-1" }
const _hoisted_20 = { class: "line3" }
const _hoisted_21 = { class: "ibm-mono-400-12 bg-Hovers/hover_grey border-[2px] px-1" }
const _hoisted_22 = {
  key: 0,
  class: "line4"
}
const _hoisted_23 = {
  key: 3,
  class: "other flex flex-col gap-5"
}
const _hoisted_24 = { class: "line1" }
const _hoisted_25 = ["href"]

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { IncrediTabList, IncrediTab } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'builds-content',
  props: {
    isFreeDev: { type: Boolean }
  },
  setup(__props: any) {


const { t } = useI18n();

const selectedTab = ref('ide');

const documentationLink = process.env.VUE_APP_GETTING_STARTED_DOCUMENTATION;

const onChange = (value: string) => {
  selectedTab.value = value;
};
const tabs = computed(() => [
  {
    name: 'ide',
    label: t('gettingStarted.steps.builds.tabs.ide.title'),
    attributes: {
      'data-testid': 'gettingStarted.steps.builds.tabs.ide.title',
    },
  },
  {
    name: 'cmd',
    label: t('gettingStarted.steps.builds.tabs.cmd.title'),
    attributes: {
      'data-testid': 'gettingStarted.steps.builds.tabs.cmd.title',
    },
  },
  {
    name: 'ninja',
    label: t('gettingStarted.steps.builds.tabs.ninja.title'),
    attributes: {
      'data-testid': 'gettingStarted.steps.builds.tabs.ninja.title',
    },
  },
  {
    name: 'other',
    label: t('gettingStarted.steps.builds.tabs.other.title'),
    attributes: {
      'data-testid': 'gettingStarted.steps.builds.tabs.other.title',
    },
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediTabList), { class: "builds-content border-b border-b-System/app_border" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab, index) => {
            return (_openBlock(), _createBlock(_unref(IncrediTab), _mergeProps({
              key: index,
              index: index,
              active: tab.name === selectedTab.value,
              style: {"width":"fit-content"}
            }, tab.attributes, {
              onClick: ($event: any) => (onChange(tab.name))
            }), {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, _toDisplayString(tab?.label), 1)
              ]),
              _: 2
            }, 1040, ["index", "active", "onClick"]))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        (selectedTab.value === 'ide')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.ide.content_1a')), 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.ide.content_1b')), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.ide.content_1c')), 1)
              ]),
              (!__props.isFreeDev)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.ide.content_2')), 1))
                : _createCommentVNode("", true)
            ]))
          : (selectedTab.value === 'cmd')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.cmd.content_1a')), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.cmd.content_1b')), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.cmd.content_1c')), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.cmd.content_2')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.cmd.content_3a')), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.cmd.content_3b')), 1)
                ]),
                (!__props.isFreeDev)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.cmd.content_4')), 1))
                  : _createCommentVNode("", true)
              ]))
            : (selectedTab.value === 'ninja')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.ninja.content_1a')), 1),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.ninja.content_1b')), 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.ninja.content_1c')), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.ninja.content_2')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.ninja.content_3a')), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.ninja.content_3b')), 1)
                  ]),
                  (!__props.isFreeDev)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.ninja.content_4')), 1))
                    : _createCommentVNode("", true)
                ]))
              : (selectedTab.value === 'other')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.other.content_1a')), 1),
                      _createElementVNode("a", {
                        href: _unref(documentationLink),
                        target: "_blank",
                        class: "text-Text/text_primary gordita-500-13 hover:underline"
                      }, _toDisplayString(_unref(t)('gettingStarted.steps.builds.tabs.other.content_1b')), 9, _hoisted_25)
                    ])
                  ]))
                : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})